interface Props {
  page: number
  pageSize: number
  total: number
  onChange: (page: number) => void
}

export default function Pagination({page, pageSize, total, onChange}: Props) {
  const pages = Math.max(1, Math.ceil(total / pageSize))
  const current = Math.min(Math.max(1, page), pages)
  if (pages <= 1) return null
  return (
    <nav className='pagination' aria-label='Paginação dos pedidos'>
      <span className='muted'>{total.toLocaleString('pt-BR')} pedidos</span>
      <button
        type='button'
        aria-label='Página anterior'
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
      >
        ‹
      </button>
      <span aria-live='polite'>
        {current} / {pages}
      </span>
      <button
        type='button'
        aria-label='Próxima página'
        disabled={current >= pages}
        onClick={() => onChange(current + 1)}
      >
        ›
      </button>
    </nav>
  )
}
